/* tslint:disable */

declare var Object: any;
export interface ActivityServiceInterface {
  "id"?: number;
}

export class ActivityService implements ActivityServiceInterface {
  "id": number;
  constructor(data?: ActivityServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ActivityService`.
   */
  public static getModelName() {
    return "ActivityService";
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of ActivityService for dynamic purposes.
   **/
  public static factory(data: ActivityServiceInterface): ActivityService{
    return new ActivityService(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'ActivityService',
      plural: 'ActivityServices',
      path: 'ActivityServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ActivityService.ts